import { createSlice } from "@reduxjs/toolkit";
import { SelectedProduct, PostCode } from "../model/product";

interface EstimateState {
    estimate_division     : number;
    selected_product      : SelectedProduct[];
    estimate_high_status  : number;
    postcode_1            : PostCode;
    postcode_2            : PostCode;
    product_consumption_status         : number;
    construction_reservation_expected_date: string;
};

const initialState = {
    estimate_division : 0,
    selected_product : [],
    estimate_high_status : 0,
    postcode_1 : {
        zip_code       : "",
        address        : "",
        detail_address : "",
        sido           : "",
        sigungu        : "",
    },
    postcode_2 : {
        zip_code       : "",
        address        : "",
        detail_address : "",
        sido           : "",
        sigungu        : "",
    },
    product_consumption_status    : 0,
    construction_reservation_expected_date: '',
} as EstimateState;

const EstimateSlice = createSlice({
    name : 'esimate_data',
    initialState,
    reducers : {
        reduxChangeEstimateDivision : (state, action) => {
            state.estimate_division = action.payload;
        },
        reduxAddEstimateSelectedProduct : (state, action) => {
            state.selected_product.push(action.payload);
        },
        reduxSubtractEstimateSelectedProduct : (state, action) => {
            state.selected_product.splice(action.payload, 1);
        },
        reduxDecreaseEstimateSelectedProductQuantity : (state, action) => {
            state.selected_product[action.payload].quantity--;
        },
        reduxIncreaseEstimateSelectedProductQuantity : (state, action) => {
            state.selected_product[action.payload].quantity++;
        },
        reduxChangeEstimateHighStatus : (state, action) => {
            state.estimate_high_status = action.payload;
        },
        reduxChangePostcode1 : (state, action) => {
            state.postcode_1 = action.payload;
        },
        reduxChangePostcode2 : (state, action) => {
            state.postcode_2 = action.payload;
        },
        reduxChangeCustomerDetailAddress1 : (state, action) => {
            state.postcode_1.detail_address = action.payload;
        },
        reduxChangeCustomerDetailAddress2 : (state, action) => {
            state.postcode_2.detail_address = action.payload;
        },
        reduxChangeEstimateProductConsumptionStatus : (state, action) => {
            state.product_consumption_status = action.payload;
        },
        reduxChangeEstimateConstructionReservationExpectedDate : (state, action) => {
            state.construction_reservation_expected_date = action.payload;
        },
        reduxResetEstimate : (state) => {
            Object.assign(state, initialState);
        },
    }
});

export const {
    reduxChangeEstimateDivision,
    reduxAddEstimateSelectedProduct,
    reduxSubtractEstimateSelectedProduct,
    reduxDecreaseEstimateSelectedProductQuantity,
    reduxIncreaseEstimateSelectedProductQuantity,
    reduxChangeEstimateHighStatus,
    reduxChangePostcode1,
    reduxChangePostcode2,
    reduxChangeCustomerDetailAddress1,
    reduxChangeCustomerDetailAddress2,
    reduxChangeEstimateProductConsumptionStatus,
    reduxChangeEstimateConstructionReservationExpectedDate,
    reduxResetEstimate,
} = EstimateSlice.actions;

export default EstimateSlice.reducer;